<style scoped lang="stylus" rel="stylesheet/stylus"></style>

<template>
	<a :href="url" class="nav-link">
		<slot></slot>
	</a>
</template>

<script>
export default {
	name: 'navigationLink2',
	components: {},
	props: {
		url: String
	},
	data() {
		return {}
	}
}
</script>
